import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";

import { INotification } from "../interfaces";

export async function NotificationPatch({
  idUser,
  operation,
  valueField,
}: INotification) {
  const url = `${endpoints.Scim2}/Users/${idUser}`;
  const data = auxiliarData.NotificationPatch({
    idUser: idUser,
    operation: operation,
    valueField: valueField,
  });
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: await useAuth.getUserToken(),
  };

  const response = await useAxios
    .patch(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`NotificationPatch error: ${response.status}`);
      }
      return { status: HTTPResponseStatus.Success, data: response.data };
    })
    .catch((error) => {
      console.error("NotificationPatch ", error);
      // toast.error(`NotificationPatch Erro: ${error?.response?.status}`);
      throw new Error();
    });

  if (response) return response;
}
